import * as React from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
import { ConsentOption } from '../';
import Button from '../../../components/Button/NewButton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 28px 16px 28px 16px;
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.2);
  :hover {
    box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.4);
  }
  @media screen and (min-width: ${themes.breakpoints.tabletLandscape}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleText = styled.span`
  ${themes.fonts.DomaineDisplay};
  font-size: 24px;
  color: ${themes.colors.KBNight};
`;

const SubtitleText = styled.span`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${themes.colors.KBNight};
  white-space: pre-wrap;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 18px;

  @media screen and (min-width: ${themes.breakpoints.tabletLandscape}) {
    padding-top: 0px;
  }
`;

type Props = {
  option: ConsentOption;
  onSelect: () => void;
};

export default class AdditionalOptionQuestion extends React.Component<Props> {
  render() {
    const { name, description } = this.props.option;
    return (
      <Container>
        <TextContainer>
          <TitleText>{name}</TitleText>
          <SubtitleText>{description}</SubtitleText>
        </TextContainer>
        <ButtonContainer>
          <Button text={'Select this option'} onClick={this.props.onSelect} />
        </ButtonContainer>
      </Container>
    );
  }
}
